import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3),
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2)
	}
}));

function PaddedContent(props) {
	let classes = styles();
	return <div className={`${classes.root} ${props.className}`}>{props.children}</div>;
}

PaddedContent.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string
};

export default PaddedContent;